import React from 'react';
import { cn } from '../../lib/utils';

/** Shared horizontal rhythm for navbar, landing sections, and footer (incl. 320px / iPhone SE). */
export const landingContainerClass =
  'mx-auto w-full min-w-0 max-w-7xl px-3 xs:px-4 sm:px-6 lg:px-8';

export default function LandingContainer({ children, className, as: Component = 'div' }) {
  return <Component className={cn(landingContainerClass, className)}>{children}</Component>;
}
